/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClonedMediaMapping } from '../models/ClonedMediaMapping';
import type { JsonNode } from '../models/JsonNode';
import type { MediaCloneJobInfo } from '../models/MediaCloneJobInfo';
import type { VaultMediaSignatureResponse } from '../models/VaultMediaSignatureResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfChatMediasService {
    /**
     * Upload media
     * Upload a media to Onlyfans and return a temporary id which can be used in sendMessages
     * @returns JsonNode Successfully uploaded media returning the of vault object
     * @throws ApiError
     */
    public static uploadChatMedia({
        creatorId,
        fileName,
        contentLength,
        requestBody,
        forcedProcessing = false,
        categoryId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given file name
         */
        fileName: string,
        contentLength: number,
        /**
         * The file as byte array
         */
        requestBody: Array<string>,
        forcedProcessing?: boolean,
        categoryId?: number,
    }): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/media/upload',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'fileName': fileName,
                'contentLength': contentLength,
                'forcedProcessing': forcedProcessing,
                'categoryId': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Clone media
     * Clone a given original media
     * @returns MediaCloneJobInfo Successfully created media clone job
     * @throws ApiError
     */
    public static cloneChatMedia({
        creatorId,
        originalMediaId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given original media id
         */
        originalMediaId: number,
    }): CancelablePromise<MediaCloneJobInfo> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/media/clone/{originalMediaId}',
            path: {
                'creatorId': creatorId,
                'originalMediaId': originalMediaId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Request the streaming of fan media
     * @returns VaultMediaSignatureResponse OK
     * @throws ApiError
     */
    public static streamV1({
        creatorId,
        userId,
        messageId,
        mediaId,
    }: {
        /**
         * ID of the creator
         */
        creatorId: number,
        /**
         * ID of the fan that sent the message
         */
        userId: number,
        /**
         * ID of the message containg the media
         */
        messageId: number,
        /**
         * ID of the media to be received
         */
        mediaId: number,
    }): CancelablePromise<VaultMediaSignatureResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/media/stream',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'userId': userId,
                'messageId': messageId,
                'mediaId': mediaId,
            },
        });
    }
    /**
     * Clone media
     * Get cloned medias
     * @returns ClonedMediaMapping Successfully created media clone job
     * @throws ApiError
     */
    public static getClonedMedia({
        creatorId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
    }): CancelablePromise<ClonedMediaMapping> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/media/cloned-media-mapping',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Get clone job info
     * Get the information about a clone job info
     * @returns MediaCloneJobInfo Successfully created media clone job
     * @throws ApiError
     */
    public static getChatCloneJobInfo({
        creatorId,
        jobId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The specified job id
         */
        jobId: string,
    }): CancelablePromise<MediaCloneJobInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/media/clone/status/{jobId}',
            path: {
                'creatorId': creatorId,
                'jobId': jobId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
}
